var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlphaZA = function SvgAlphaZA(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 4.7h-4.7l2.4-2.4zm-4.6 14.7H15l-2.3 2.3zm6-13.1-4.5 11.5h1.8l.9-2.5h5.1l.9 2.5h1.8L18 6.3zm-1.1 7.3 1.9-5.2 1.9 5.2zM5 16.1h6.1v1.6H2.6v-1.3l5.9-8.6H2.6V6.3h8.3v1.3z"
  })));
};
export default SvgAlphaZA;